import styled from 'styled-components';

export const StyledPagination = styled.div`
  margin-top: 20px;
  .pagination {

    .page-item {
      display: inline;
      margin-right: 5px;
      
      &.active .page-link {
        background: linear-gradient(120deg, #3a2a1a 60%, #2a1510 100%);
        color: #ff6b35;
        border: 2px solid #ff6b35;
        box-shadow: 0 0 8px 1px #ff6b35;
        border-radius: 6px;
      }
      
      .page-link {
        color: #fff;
        background: linear-gradient(120deg, #2a1a0f 60%, #1a0f08 100%);
        border: 2px solid #ff4500;
        padding: 8px 12px;
        cursor: pointer;
        border-radius: 6px;
        transition: all 0.3s ease;
        box-shadow: 0 0 4px 0.5px #ff4500;
        
        &:hover {
          border: 2px solid #ff6b35;
          box-shadow: 0 0 8px 1px #ff6b35;
          background: linear-gradient(120deg, #3a2a1a 60%, #2a1510 100%);
          color: #ff6b35;
        }
      }
    }
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  text-align: left;
  background: linear-gradient(120deg, #2a1a0f 60%, #1a0f08 100%);
  color: #fff;
  table-layout: auto; 
  overflow-x: auto;
  border: 2px solid #ff4500;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 4px 0.5px #ff4500;

  @media (max-width: 768px) {
    .btn {
      padding: 0.25rem 0.5rem; 
      font-size: 0.875rem;
      .fa { 
        display: none;
      }
    }
  }

  th {
    background: linear-gradient(120deg, #3a2a1a 60%, #2a1510 100%);
    color: #ff6b35;
    padding: 12px 15px;
    border-bottom: 2px solid #ff4500;
    font-weight: 600;
  }

  td {
    padding: 10px 15px;
    border-bottom: 1px solid #ff450055;
  }

  tr:nth-child(even) {
    background: linear-gradient(120deg, #1f1408 60%, #0f0804 100%);
  }

  tr:hover {
    background: linear-gradient(120deg, #3a2a1a 60%, #2a1510 100%);
    cursor: pointer;
    box-shadow: inset 0 0 4px 0.5px #ff4500;
  }

  th.actions, td.actions {
    text-align: right;
  }
`;

export const StyledInstructions = styled.div`
  background: linear-gradient(120deg, #2a1a0f 60%, #1a0f08 100%);
  color: #fff;
  padding: 12px 15px;
  border-radius: 12px;
  border: 2px solid #ff4500;
  font-size: 16px;
  box-shadow: 0 0 4px 0.5px #ff4500;
  transition: all 0.3s ease;

  &:hover {
    border: 2px solid #ff6b35;
    box-shadow: 0 0 8px 1px #ff6b35;
    background: linear-gradient(120deg, #3a2a1a 60%, #2a1510 100%);
  }
`;
